export default __webpack_public_path__ + "static/media/deleteEligibility.8416c7a9.svg";